import { all } from 'redux-saga/effects'
import watchMultisiteSelectorFilterRequest from './watchMultisiteSelectorFilterRequest'
import watchMultisiteSelectorGetRequest from './watchMultisiteSelectorGetRequest'
import watchMultisiteSelectorUpdateRequest from './watchMultisiteSelectorUpdateRequest'

export default function* multisiteSelectorSaga() {
    yield all([
        watchMultisiteSelectorGetRequest(),
        watchMultisiteSelectorUpdateRequest(),
        watchMultisiteSelectorFilterRequest()
    ])
}